import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
  padding: 4rem 2rem 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  margin-bottom: 2rem;
`;

const FooterSection = styled(motion.div)`
  
`;

const SectionTitle = styled.h3`
  color: #3b82f6;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const FooterText = styled.p`
  color: #94a3b8;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const FooterLink = styled.div`
  color: #94a3b8;
  padding: 0.5rem 0;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #3b82f6;
  }
`;

const ContactInfo = styled.div`
  color: #94a3b8;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Copyright = styled.div`
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #64748b;
  font-size: 0.9rem;
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: 800;
  background: linear-gradient(135deg, #3b82f6, #06b6d4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1rem;
`;

function Footer() {
  return (
    <FooterContainer id="contact">
      <FooterContent>
        <FooterGrid>
          <FooterSection
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Logo>ADAPTEC BUILDING SOLUTIONS</Logo>
            <FooterText>
              Revolutionary rebar coupler technology delivering superior structural 
              connections with proven performance and significant cost savings.
            </FooterText>
            <FooterText>
              Trusted by leading contractors across India for critical infrastructure projects.
            </FooterText>
          </FooterSection>

          <FooterSection
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <SectionTitle>Products</SectionTitle>
            <FooterLink>Threaded Couplers</FooterLink>
            <FooterLink>Swaged Couplers</FooterLink>
            <FooterLink>Grout-filled Couplers</FooterLink>
            <FooterLink>Adhesive Couplers</FooterLink>
            <FooterLink>Marine Grade Solutions</FooterLink>
          </FooterSection>

          <FooterSection
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <SectionTitle>Applications</SectionTitle>
            <FooterLink>High-Rise Buildings</FooterLink>
            <FooterLink>Bridge Construction</FooterLink>
            <FooterLink>Marine Structures</FooterLink>
            <FooterLink>Infrastructure Projects</FooterLink>
            <FooterLink>Precast Elements</FooterLink>
          </FooterSection>

          <FooterSection
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <SectionTitle>Contact Information</SectionTitle>
            <ContactInfo>
              📧 info@adaptec.in
            </ContactInfo>
            <ContactInfo>
              📞 +91-99660-03326
            </ContactInfo>
            <ContactInfo>
              📍 107, NEW STEEL CITY, DOOLAPALLY, JEEDIMETLA, HYDERABAD - 500014
            </ContactInfo>
            <ContactInfo>
              🆔 GSTIN: 36AAXCA1450G1ZK
            </ContactInfo>
            <ContactInfo>
              🌐 www.adaptec.in
            </ContactInfo>
          </FooterSection>
        </FooterGrid>

        <Copyright>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            © 2024 ADAPTEC BUILDING SOLUTIONS PRIVATE LIMITED. All rights reserved. | 
            Built with innovative web technology | 
            Rebar Couplers - Revolutionizing Construction
          </motion.div>
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer;